import Header from '../../Header';
import MainBlock from './MainBlock';
import TabletBlock from './TabletBlock';

function Home(){

    return(
        <>
        <Header/>
        <MainBlock/>
        <TabletBlock/>
        </>
    );
}

export default Home;